import RestAPI from "../util/RestAPI";

export async function getCurrentEnvironment() {
  return (await RestAPI.get("/env")).text();
}
